import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import * as moment from 'moment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Component({
  selector: 'app-ia-marks',
  templateUrl: './ia-marks.component.html',
  styleUrls: ['./ia-marks.component.scss']
})
export class IaMarksComponent implements OnInit {
  IAMarksForm: FormGroup;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  userPermission: any;
  Table = false;
  SaveBtn = false;
  UpdateBtn = false;
  CoCode = 0;
  CgCode = 0;
  isBranch = false;
  filteredListBranch
  UserCollege: any;
  subcode: string;
  SomeMarksNull: boolean;
  filteredsubjectList: any[];
  filteredListExam: any[];
  collegeList: any;
  filteredCollegeList: any;
  sessionNo: any;
  closeMessage: string;
  message: string;
  finalPayload: any[] = [];
  HeadList: any;
  examList
  CourseList: any;
  filteredListCourse: any;
  coCode: any;
  subjectList = []
  emid
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sub: any;
  IsFile = false;
  IsFileUpload = false;
  passMarks: any;
  maxMarks: any;
  BranchList: any;
  filteredListHead: any[];
  head: any;
  headcode: any;
  assignTableData: any[];
  FileIAData: any[];
  StuArray: FormArray;
  errMsg: any;
  submitpayload: any;
  Student: any;
  currentDate: Date;
  finalPayloadUpdate: any[] = [];
  savedpayload: any;
  SubMarkList: any;
  IAMarks = 0;
  IAmarksCounts
  AssStatus
  saveDisable: boolean;
  errMsgInvalid: boolean[] = [];
  updateDisable: boolean;
  status: any;
  pageSize = 10;
  pageSizeOptions: number[] = [2, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  examRecords;
  StuIAMarksId: any[] = [];
  utp: string;
  formativeASSCreate = true
  formativeASSUpdate = true
  statusList: any[];
  filteredStatusList: any[];
  CoName: any;
  CgName: any;
  BranchName: any;
  EditMode: boolean;
  allMarksNull: boolean;
  dynamicHeads = [];
  isFinalSubmitted = false;
  isDownloading = false;

  reportCollegeList: any[] = [];
  filteredReportCollegeList: any[] = [];
  selectedReportColleges: string[] = [];
  commaSeparatedReportColleges: string = '';

  private _updatingReportFromMarking = false;

  // Monotonically increasing token used to identify the "latest" marks-fetch
  // request. Any in-flight request whose token no longer matches
  // this.requestToken by the time it resolves is stale and is discarded.
  // This prevents marks from one subject/head-set overwriting the table
  // after the user has already switched to a different subject/exam/branch,
  // which was the root cause of heads' marks appearing "mixed".
  private requestToken = 0;
  private inputTimeouts: Map<string, any> = new Map();

  isSessionClosed: boolean = false;
  sessionCutoffStartDate: string = '';
  sessionCutoffEndDate: string = '';
  sessionCutoffMessage: string = '';

  constructor(private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if (this.userPermission && this.userPermission.length > 0) {
      this.UserCollege = this.userPermission[0].CgUi == 'C' ? this.userPermission[0].CgId : '';
    }

    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    this.Table = false
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.IsFile = false
    this.IsFileUpload = false;
    this.IAMarks = 0;
    this.saveDisable = false
    this.updateDisable = false
    this.IAMarksForm = this.fb.group({
      college: new FormControl('', Validators.required),
      course: new FormControl('', Validators.required),
      SessionId: new FormControl('', Validators.required),
      EmId: new FormControl('', Validators.required),
      SubCode: new FormControl(''),
      EsId: new FormControl(''),
      Branch: new FormControl(''),
      EsParentId: new FormControl('', Validators.required),
      StuArray: new FormArray([]),
      IAMarks: new FormControl(''),
      SearchString: new FormControl(''),
      IAStudentStatus: new FormControl(''),
    });
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'IA Marks' && element.PCreate == false) {
          this.formativeASSCreate = false;
        }
        if (element.PageName == 'IA Marks' && element.PUpdate == false) {
          this.formativeASSUpdate = false;
        }
      });
    }
    this.fetchSession();
    this.fetchStatus();
    this.currentDate = new Date();

    this.IAMarksForm.get('college').valueChanges.subscribe((newCollege: string) => {
      if (this._updatingReportFromMarking) return;

      if (newCollege && this.reportCollegeList.some(c => c.CgCode === newCollege)) {
        this.selectedReportColleges = [newCollege];
        this.commaSeparatedReportColleges = newCollege;
      } else {
        this.selectedReportColleges = [];
        this.commaSeparatedReportColleges = '';
      }
    });
  }

  getStuArrayControls() {
    return (this.IAMarksForm.get('StuArray') as FormArray).controls;
  }

  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.filteredCollegeList = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

  getCollege(item) {
    this.getExamList(item);
    this.spinner.show();
    if (this.userPermission && this.userPermission.length > 0) {
      this.UserCollege = this.userPermission[0].CgUi == 'C' ? this.userPermission[0].CgId : '';
    } else {
      this.UserCollege = '';
    }
    this.IsFile = false;
    this.Table = false;
    this.SaveBtn = false;
    this.subcode = '';
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    const payload = {};
    payload['CoCode'] = item.CoCode
    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      if (this.UserCollege) {
        this.collegeList = this.collegeList.filter(college =>
          college.CgCode === this.UserCollege
        );
      }

      this.filteredCollegeList = this.collegeList.slice();
      this.reportCollegeList = this.collegeList.slice();
      this.filteredReportCollegeList = this.reportCollegeList.slice();
      if (this.collegeList.length === 1) {
        this.IAMarksForm.get('college').setValue(this.collegeList[0].CgCode);
      }

      const currentMarkingCollege = this.IAMarksForm.get('college').value;
      if (currentMarkingCollege && this.reportCollegeList.some(c => c.CgCode === currentMarkingCollege)) {
        this._updatingReportFromMarking = true;
        this.selectedReportColleges = [currentMarkingCollege];
        this.commaSeparatedReportColleges = currentMarkingCollege;
        this._updatingReportFromMarking = false;
      } else {
        this.selectedReportColleges = [];
        this.commaSeparatedReportColleges = '';
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
      this.reportCollegeList = [];
      this.filteredReportCollegeList = [];
    })
  }

  getCourse(data) {
    this.CgName = data.CgName
    this.spinner.show();
    this.CgCode = data.CgCode
    this.sessionNo = data.SnNo
    this.closeMessage = '';
    this.message = ''
    this.finalPayload = []
    let payload2 = this.IAMarksForm.value
    this.Table = false
    this.SaveBtn = false;
    this.isBranch = false;
    this.IsFile = false;
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.examList = []
    this.IAMarksForm.get('college').setValue('');
    this.selectedReportColleges = [];
    this.commaSeparatedReportColleges = '';
    // Invalidate any marks fetch that might still be in flight for a
    // previous selection.
    this.requestToken++;

    const payload = {};
    payload['SessionId'] = payload2.SessionId;
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getExamList(item) {
    this.spinner.show();
    this.closeMessage = ''
    this.message = ''
    this.finalPayload = []
    this.IsFile = false;
    this.Table = false;
    this.filteredsubjectList = [];
    this.examList = []
    this.isBranch = false;
    // Invalidate any marks fetch that might still be in flight.
    this.requestToken++;
    const payload = {};
    payload['EmCoCode'] = item.CoCode;
    this.filteredsubjectList = [];
    this.examList = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();

    });
  }

  getSubject(e) {
    this.IsFile = false;
    this.spinner.show();
    this.Table = false;
    this.isBranch = false;
    this.BranchList = [];
    this.subjectList = [];
    this.filteredsubjectList = []
    this.emid = e.EmId;
    // Invalidate any marks fetch that might still be in flight for a
    // previously selected exam/subject.
    this.requestToken++;
    if (e.EmStreams == "Y") {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
    } else {
      this.isBranch = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        this.spinner.hide();
        res.data.children.forEach(element => {

          if (element.EsType == 'S') {
            this.subjectList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();

        });
      });
    }

  }


  fetchBranch(id) {
    this.spinner.show();
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = [];
    this.HeadList = [];
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  getCoColStrMapping(id) {
    this.spinner.show();
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = [];
    this.HeadList = [];
    let payload2 = this.IAMarksForm.value;
    payload['EmId'] = id;
    payload['CoCode'] = this.coCode;
    payload['CgCode'] = payload2.college;
    this.umsService.fetchCoColStrMapping(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  getStr(e) {
    this.BranchName = e.StrName
    this.closeMessage = ''
    this.message = ''
    this.finalPayload = []
    this.spinner.show();
    this.Table = false;
    this.IsFile = false;
    this.filteredsubjectList = [];
    this.subjectList = []
    this.HeadList = [];
    // Invalidate any marks fetch that might still be in flight for a
    // previously selected branch.
    this.requestToken++;
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = this.IAMarksForm.value.Branch;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.subjectList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();

        });
      }
      else {
        this.subjectList = [];
        this.filteredsubjectList = [];

      }

    }, (ERROR: HttpErrorResponse) => {
      this.subjectList = [];
      this.filteredsubjectList = [];
    });
  }

  subjectClick(data) {
    this.closeMessage = ''
    this.message = ''
    this.spinner.show();
    this.HeadList = [];
    this.dynamicHeads = [];
    this.filteredListHead = [];
    this.Table = false;
    this.IsFile = false;
    this.subcode = data.EsCode;
    this.finalPayload = []

    // Bump the token as soon as the user picks a (possibly new) subject so
    // that any HeadList/marks fetch belonging to a previous subject is
    // recognised as stale and ignored once it resolves.
    const requestToken = ++this.requestToken;

    const payload = {};
    payload['EsId'] = data.EsId;

    this.umsService.getStuIASub(payload).subscribe(res => {
      // A newer subject/exam/branch has been selected since this call was
      // fired - discard this response instead of populating the table with
      // heads that no longer match the current selection.
      if (requestToken !== this.requestToken) {
        return;
      }

      if (res.status) {
        this.HeadList = res.data;

        this.dynamicHeads = res.data.map(head => ({
          code: head.EsCode,
          label: head.EsName,
          maxmarks: head.EsMaxMarks,
          passmarks: head.EsPassMarks,
          esId: head.EsId,
          type: 'marks'
        }));

        this.filteredListHead = this.HeadList.slice();
        this.ShowTableWithLoop(requestToken);
      }
      else {
        let data = {}
        data['message'] = 'No Internal Assignment Paper Found'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.HeadList = [];
        this.IAMarksForm.controls['EsParentId'].setValue('');
      }

    }, (ERROR: HttpErrorResponse) => {
      if (requestToken !== this.requestToken) {
        return;
      }
      this.spinner.hide();
      let data = {}
      data['message'] = 'No IA Heads Found'
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.HeadList = [];
      this.IAMarksForm.controls['EsParentId'].setValue('');
    })
  }
  ShowTableWithLoop(requestToken: number = ++this.requestToken) {
    this.spinner.show();
    this.Table = false;
    let payload2 = this.IAMarksForm.value;
    this.StuArray = this.IAMarksForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [];

    const headsSnapshot = [...this.dynamicHeads];
    const subcodeSnapshot = this.subcode;

    if (headsSnapshot.length === 0) {
      this.spinner.hide();
      return;
    }

    const headObservables = headsSnapshot.map(head => {
      const payload = {};
      payload['SessionId'] = payload2.SessionId;
      payload['CoCode'] = payload2.course;
      payload['EsCode'] = subcodeSnapshot;
      payload['HeadCode'] = head.code;
      payload['CgCode'] = payload2.college;
      payload['EmId'] = payload2.EmId;
      payload['Branch'] = payload2.Branch ? payload2.Branch : "0";
      payload['UserId'] = sessionStorage.getItem('userId');

      return this.umsService.getStuIAMarks(payload).pipe(
        map((res: any) => ({ headCode: head.code, res, ok: true })),
        catchError((error: HttpErrorResponse) => of({ headCode: head.code, res: null, ok: false, error }))
      );
    });

    forkJoin(headObservables).subscribe((results: any[]) => {
      if (requestToken !== this.requestToken) {
        return;
      }

      const allResponses = [];
      let hasError = false;

      results.forEach((result: any) => {
        if (result.ok && result.res && result.res.status) {
          allResponses.push({ headCode: result.headCode, data: result.res.data });
        } else {
          hasError = true;
        }
      });

      if (hasError || allResponses.length === 0) {
        this.spinner.hide();
        this.assignTableData = [];
        this.totalItems = 0;
        this.UpdateBtn = false;
        let data = {};
        data['message'] = 'No Data Found';
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.checkSessionCutOff();
        return;
      }

      this.processMultipleHeadResponses(allResponses, headsSnapshot);
      this.fetchSupExamRecord();
      this.checkSessionCutOff();
      this.spinner.hide();
    }, () => {
      if (requestToken !== this.requestToken) {
        return;
      }
      this.spinner.hide();
      this.assignTableData = [];
      this.totalItems = 0;
      this.UpdateBtn = false;
      let data = {};
      data['message'] = 'No Data Found';
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.checkSessionCutOff();
    });
  }

  processMultipleHeadResponses(allResponses, heads = this.dynamicHeads) {
    const groupedData = new Map();

    allResponses.forEach(response => {
      response.data.forEach(item => {
        if (!groupedData.has(item.StuId)) {
          const { HeadCode, IAMarks, IAMarksStatus, IAStudentStatus, StuIAMarksId, ...studentData } = item;
          groupedData.set(item.StuId, {
            ...studentData,
            marks: {}
          });
        }

        const student = groupedData.get(item.StuId);
        student.marks[response.headCode] = {
          Marks: item.IAMarks,
          Status: item.IAStudentStatus || '',
          StuIAMarksId: item.StuIAMarksId,
          ScrutinyId: item.ScrutinyId || 0
        };
      });
    });

    this.assignTableData = Array.from(groupedData.values());
    this.Table = true;

    const allHeadsFinalSubmitted =
      allResponses.length === heads.length &&
      allResponses.every(response =>
        response.data.length > 0 &&
        response.data.every(row => row.IAMStatus === 'Y')
      );

    this.isFinalSubmitted = allHeadsFinalSubmitted;

    const allMarksNull = this.assignTableData.every(item => {
      return heads.every(head => {
        const markValue = item.marks[head.code]?.Marks;
        return markValue === null || markValue === '' || markValue === undefined;
      });
    });

    this.allMarksNull = allMarksNull;

    this.assignTableData.forEach((element) => {
      const creds = this.IAMarksForm.get('StuArray') as FormArray;
      const marksGroup = this.fb.group({});

      heads.forEach(head => {
        const defaultValue = element.marks[head.code]?.Marks ?? '';
        const statusValue = element.marks[head.code]?.Status || '';

        marksGroup.addControl(head.code, new FormControl(defaultValue));
        marksGroup.addControl(`${head.code}_Status`, new FormControl(statusValue));
        marksGroup.addControl(`${head.code}_StuIAMarksId`, new FormControl(element.marks[head.code]?.StuIAMarksId || null));
        marksGroup.addControl(`${head.code}_ScrutinyId`, new FormControl(element.marks[head.code]?.ScrutinyId || 0));
      });

      creds.push(
        this.fb.group({
          SeatNo: new FormControl(element['RollNo']),
          Name: new FormControl(
            `${element.StuFirstNameEng} ${element.StuMidNameEng} ${element.StuLastNameEng}`
          ),
          StuId: new FormControl(element['StuId']),
          marks: marksGroup
        })
      );
    });

    const hasAnyMarks = allResponses.some(response =>
      response.data.some(row =>
        row.IAMarks !== null &&
        row.IAMarks !== undefined &&
        row.IAMarks !== ''
      )
    );

    if (hasAnyMarks) {
      this.UpdateBtn = true;
      this.SaveBtn = false;
    } else {
      this.UpdateBtn = false;
      this.SaveBtn = true;
    }
  }

  checkSessionCutOff() {
    this.spinner.show();
    let payload2 = this.IAMarksForm.value;
    const payload = {};
    payload['SessionID'] = payload2.SessionId;
    payload['CoCgCgCode'] = payload2.college;
    payload['CoCgCoCode'] = payload2.course;
    payload['InCode'] = 'IAMar';
    payload['EmId'] = payload2.EmId;
    
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      
      if (res.status && res.data && res.data.length > 0) {
        const data = res.data[res.data.length - 1];
        
        if (data && data.CutOffDateFrom && data.CutOffDate) {

          const cutOffDateFrom = new Date(data.CutOffDateFrom);
          const cutOffDate = new Date(data.CutOffDate);
          const currentDate = new Date();

          const startDate = new Date(cutOffDateFrom.getFullYear(), cutOffDateFrom.getMonth(), cutOffDateFrom.getDate());
          const endDate = new Date(cutOffDate.getFullYear(), cutOffDate.getMonth(), cutOffDate.getDate());
          const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

          this.sessionCutoffStartDate = moment(cutOffDateFrom).format('DD/MM/YYYY');
          this.sessionCutoffEndDate = moment(cutOffDate).format('DD/MM/YYYY');


          if (today >= startDate && today <= endDate) {
            this.isSessionClosed = false;
            this.message = ` Session is active: ${this.sessionCutoffStartDate} to ${this.sessionCutoffEndDate}`;
            this.closeMessage = '';
            this.enableEditing(true);
          } else {
            this.isSessionClosed = true;
            this.closeMessage = `Session closed. Valid from ${this.sessionCutoffStartDate} to ${this.sessionCutoffEndDate}`;
            this.message = '';
            this.enableEditing(false);
            
            // Show alert to user
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: `The session is closed. You cannot edit or save marks. Session was valid from ${this.sessionCutoffStartDate} to ${this.sessionCutoffEndDate}.`,
              title: 'Session Closed',
              icon: 'fas fa-clock'
            });
          }
        } else {
          this.isSessionClosed = true;
          this.closeMessage = ' No session cutoff dates configured. Please contact administrator.';
          this.enableEditing(false);
        }
      } else {
        this.isSessionClosed = true;
        this.closeMessage = ' No session cutoff dates configured. Please contact administrator.';
        this.enableEditing(false);
        this.SaveBtn = false;
        this.UpdateBtn = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.isSessionClosed = true;
      this.closeMessage = ' Error fetching session cutoff. Please try again.';
      this.enableEditing(false);
    });
  }


  private enableEditing(enabled: boolean) {
    if (!enabled) {
      // Disable all form controls
      this.IAMarksForm.disable();
      this.SaveBtn = false;
      this.UpdateBtn = false;
      this.saveDisable = true;
      this.updateDisable = true;
    } else {
      // Enable form controls
      this.IAMarksForm.enable();
      this.saveDisable = false;
      this.updateDisable = false;
      
      // Restore button states based on marks existence
      if (this.assignTableData && this.assignTableData.length > 0) {
        const hasMarks = this.assignTableData.some(student => {
          return this.dynamicHeads.some(head => {
            const mark = student.marks?.[head.code]?.Marks;
            return mark !== null && mark !== '' && mark !== undefined;
          });
        });
        
        if (hasMarks) {
          this.UpdateBtn = true;
          this.SaveBtn = false;
        } else {
          this.UpdateBtn = false;
          this.SaveBtn = true;
        }
      }
    }
  }

  // UPDATED: Save with session check
  save() {
    if (this.isSessionClosed) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: ' Cannot save marks. The session is closed.',
        title: 'Access Denied',
        icon: 'fas fa-times'
      });
      return;
    }
    this.saveIA();
  }

  private sendMarks(updateMode: boolean): Observable<any> {
    const submitpayload = this.IAMarksForm.value;
    const payloadArray: any[] = [];
    const stuArray = this.IAMarksForm.get('StuArray') as FormArray;
    const students = stuArray.value;

    students.forEach(student => {
      this.dynamicHeads.forEach(head => {
        const marks = student.marks[head.code];
        const studentStatus = student.marks[`${head.code}_Status`];
        const stuIAMarksId = student.marks[`${head.code}_StuIAMarksId`];
        const scrutinyId = student.marks[`${head.code}_ScrutinyId`];

        let iaMarks = 0;
        let iaMarksStatus = 'F';
        let iaStudentStatus = '';

        if (studentStatus === 'AB') {
          iaMarks = 0;
          iaMarksStatus = 'F';
          iaStudentStatus = 'AB';
        } else {
          iaMarks = marks ?? 0;
          if (marks && marks !== '' && marks !== null) {
            iaMarksStatus = (iaMarks >= head.passmarks && iaMarks <= head.maxmarks) ? 'P' : 'F';
          }
        }

        const Payload = {
          SessionID: submitpayload.SessionId,
          CoCode: submitpayload.course,
          CgCode: submitpayload.college,
          EmId: submitpayload.EmId,
          Branch: submitpayload.Branch || "0",
          EsId: head.esId,
          EsParentId: submitpayload.EsParentId,
          HeadCode: head.code,
          SubCode: this.subcode,
          StuId: student.StuId,
          IAMarks: iaMarks,
          IAStudentStatus: iaStudentStatus,
          IAMarksStatus: iaMarksStatus,
          UserID: parseInt(sessionStorage.getItem('userId')),
          EntryDateTime: this.currentDate,
          IsFinal: 'N'
        };

        if (updateMode) {
          payloadArray.push({
            ...Payload,
            StuIAMarksId: stuIAMarksId,
            ScrutinyID: scrutinyId
          });
        } else {
          payloadArray.push(Payload);
        }
      });
    });

    const serviceCall = updateMode
      ? this.umsService.updateStuIAMarksSet(payloadArray)
      : this.umsService.saveStuIAMarksSet(payloadArray);

    return serviceCall;
  }

  saveIA() {
    this.spinner.show();
    this.sendMarks(false).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = "✅ Saved Successfully";
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(() => {
            this.ShowTableWithLoop();
          });
        } else {
          this.showError(res.message || 'Save failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.showError(ERROR.error.message);
      }
    });
  }


  update() {
    if (this.isSessionClosed) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: ' Cannot update marks. The session is closed.',
        title: 'Access Denied',
        icon: 'fas fa-times'
      });
      return;
    }
    this.updateIA();
  }

  updateIA() {
    this.spinner.show();
    this.sendMarks(true).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = " Updated Successfully";
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(() => {
            this.ShowTableWithLoop();
          });
        } else {
          this.showError(res.message || 'Update failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.showError(ERROR.error.message);
      }
    });
  }


  SaveFinal() {
    if (this.isSessionClosed) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Cannot submit final marks. The session is closed.',
        title: 'Access Denied',
        icon: 'fas fa-times'
      });
      return;
    }

    const isValid = this.validateAllMarks();

    if (!isValid) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: "Please fill in all IA Marks or mark students as Absent (AB) before final submission.",
        title: "Validation Error",
        icon: "fas fa-exclamation-triangle"
      });
      return;
    }

    const data: any = {
      message: "Are you sure you want to make your final submission for IA marks? Any unsaved changes will be saved first, and you won't be able to make any changes afterward.",
      title: "Alert",
      icon: "fa fa-question",
    };

    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === "yes") {
        this.spinner.show();
        const useUpdate = this.UpdateBtn;
        this.sendMarks(useUpdate).subscribe({
          next: (saveRes) => {
            if (!saveRes.status) {
              this.spinner.hide();
              this.showError(saveRes.message || 'Failed to save marks before final submission');
              return;
            }
            this.SubmitFinal();
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.showError(ERROR.error.message);
          }
        });
      }
    });
  }

  validateAllMarks(): boolean {
    const stuArray = this.IAMarksForm.get('StuArray') as FormArray;

    for (let i = 0; i < stuArray.length; i++) {
      const studentGroup = stuArray.at(i) as FormGroup;
      const marksGroup = studentGroup.get('marks') as FormGroup;

      for (let head of this.dynamicHeads) {
        const marksValue = marksGroup.get(head.code)?.value;
        const statusValue = marksGroup.get(`${head.code}_Status`)?.value;

        if ((marksValue === '' || marksValue === null || marksValue === undefined) && statusValue !== 'AB') {
          return false;
        }
      }
    }

    return true;
  }

  SubmitFinal() {
    const submitpayload = this.IAMarksForm.value;
    let completedCalls = 0;
    let hasError = false;

    this.dynamicHeads.forEach(head => {
      const payload: any = {
        SessionID: submitpayload.SessionId,
        CoCode: submitpayload.course,
        CgCode: submitpayload.college,
        EmId: submitpayload.EmId,
        EsParentId: submitpayload.EsParentId,
        HeadCode: head.code,
        IsFinal: "Y",
      };

      this.umsService.saveFinalIAmark(payload).subscribe((res) => {
        completedCalls++;

        if (!res.status) {
          hasError = true;
        }

        if (completedCalls === this.dynamicHeads.length) {
          this.spinner.hide();

          if (hasError) {
            this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
              message: "Failed to submit some final IA marks. Please try again.",
              title: "Error",
              icon: "fas fa-times",
            });
            this.ShowTableWithLoop();
          } else {
            const data = {
              message: "✅ Final Submit Successfully",
              title: "Information",
              icon: "fas fa-check",
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.dialogRef.afterClosed().subscribe(() => {
              this.ShowTableWithLoop();
            });
          }
        }
      }, (ERROR: HttpErrorResponse) => {
        completedCalls++;
        hasError = true;

        if (completedCalls === this.dynamicHeads.length) {
          this.spinner.hide();
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: ERROR.error.message || "Failed to submit final IA marks.",
            title: "Error",
            icon: "fas fa-times",
          });
          this.ShowTableWithLoop();
        }
      });
    });
  }

  private showError(message: string): void {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: message,
      title: "Error",
      icon: "fas fa-times"
    });
  }

  fetchSupExamRecord() {
    this.spinner.show();
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = this.IAMarksForm.value.SessionId;
    this.umsService.getSupExamRecord(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        res.data.forEach(element => {
          if (element.ShEmId == this.IAMarksForm.value.EmId) {
            // this.check(element.ShId)
          }
        });
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  check(ShId) {
    this.spinner.show();
    const payload = {
      EcInCode: 19,
      EcShId: ShId,
      EcOpId: sessionStorage.getItem('userId')
    };

    this.umsService.getSupExamEditRecord(payload).subscribe(res => {
      this.spinner.hide();
      const records = res.data;
      if (Array.isArray(records) && records.length > 0) {
        const isEditControlOpen = records.some(item => item.EcStatus === 'O');
        if (isEditControlOpen) {
          this.updateDisable = true;
          this.saveDisable = true;
          this.SaveBtn = false;
          this.UpdateBtn = false;
          this.IsFileUpload = true;
          const data = {
            message: 'Exam Edit List Updated, Cannot Update',
            title: 'Information',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        } else {
          this.updateDisable = false;
          this.saveDisable = false;
          this.IsFileUpload = false;
        }
      } else {
        this.updateDisable = false;
        this.saveDisable = false;
        this.IsFileUpload = false;
      }
    });
  }

  keypress() {
    this.spinner.show();
    if (this.setIntervalSearch) {
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(() => {
      this.ShowTableWithLoop();
    }, 1000);
  }

  onInputChange(event: any, studentIndex: number, headCode: string, headMaxMarks: number): void {
    // Check if session is closed before allowing input
    if (this.isSessionClosed) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Cannot enter marks. The session is closed.',
        title: 'Access Denied',
        icon: 'fas fa-times'
      });
      event.target.value = '';
      return;
    }

    const enteredValue = event.target.value.trim();
    const stuArray = this.IAMarksForm.get('StuArray') as FormArray;
    const studentGroup = stuArray.at(studentIndex) as FormGroup;
    const marksGroup = studentGroup.get('marks') as FormGroup;

    const inputKey = `${studentIndex}_${headCode}`;

    if (this.inputTimeouts.has(inputKey)) {
      clearTimeout(this.inputTimeouts.get(inputKey));
      this.inputTimeouts.delete(inputKey);
    }

    if (enteredValue === '') {
      return;
    }

    const timeout = setTimeout(() => {
      this.validateMarksInput(studentIndex, headCode, headMaxMarks);
      this.inputTimeouts.delete(inputKey);
    }, 1000);
    
    this.inputTimeouts.set(inputKey, timeout);
  }

  private validateMarksInput(studentIndex: number, headCode: string, headMaxMarks: number): void {
    const stuArray = this.IAMarksForm.get('StuArray') as FormArray;
    const studentGroup = stuArray.at(studentIndex) as FormGroup;
    const marksGroup = studentGroup.get('marks') as FormGroup;
    const currentValue = marksGroup.get(headCode)?.value;
    
    if (currentValue === '' || currentValue === null || currentValue === undefined) {
      return;
    }

    const marks = Number(currentValue);
    const head = this.dynamicHeads.find(h => h.code === headCode);

    if (marks > headMaxMarks) {
      const data = {
        message: `Marks cannot be greater than ${headMaxMarks}`,
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        marksGroup.get(headCode)?.setValue('');
      });
      return;
    }

    if (isNaN(marks) || marks < 0) {
      marksGroup.get(headCode)?.setValue('');
      return;
    }

    if (head && marks > 0 && marks < head.passmarks) {
      const confirmData = {
        message: `The entered marks (${marks}) are below the pass marks (${head.passmarks}). Do you still want to enter these marks?`,
        title: 'Confirmation',
        icon: 'fa fa-question'
      };
      
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, confirmData);
      
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result === "yes") {
          this.formatAndSetMarks(marksGroup, headCode, currentValue.toString());
          marksGroup.get(`${headCode}_Status`)?.setValue('');
        } else {
          marksGroup.get(headCode)?.setValue('');
          marksGroup.get(`${headCode}_Status`)?.setValue('');
        }
      });
      return;
    }
    this.formatAndSetMarks(marksGroup, headCode, currentValue.toString());
  }

  private formatAndSetMarks(marksGroup: FormGroup, headCode: string, enteredValue: string): void {
    if (/^\d{1}$/.test(enteredValue)) {
      const formattedValue = enteredValue.padStart(2, '0');
      marksGroup.get(headCode)?.setValue(formattedValue, { emitEvent: false });
    } else if (/^\d{2}$/.test(enteredValue)) {
      marksGroup.get(headCode)?.setValue(enteredValue, { emitEvent: false });
    } else {
      marksGroup.get(headCode)?.setValue(enteredValue, { emitEvent: false });
    }
  }

  fetchStatus() {
    this.spinner.show();
    const payload = {};
    this.statusList = [];
    this.filteredStatusList = [];
    payload['CdType'] = 'IAST';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.statusList = res.data;
        this.filteredStatusList = this.statusList.slice();
      }
    });
  }

  onStatusChange(selectedStatus: string, studentIndex: number, headCode: string) {
    // Check if session is closed before allowing status change
    if (this.isSessionClosed) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: ' Cannot change status. The session is closed.',
        title: 'Access Denied',
        icon: 'fas fa-times'
      });
      return;
    }

    const stuArray = this.IAMarksForm.get('StuArray') as FormArray;
    const studentGroup = stuArray.at(studentIndex) as FormGroup;
    const marksGroup = studentGroup.get('marks') as FormGroup;

    if (selectedStatus === 'AB') {
      marksGroup.get(headCode)?.setValue('0');
      marksGroup.get(headCode)?.clearValidators();
    } else {
      marksGroup.get(headCode)?.setValue('');
    }
    marksGroup.get(headCode)?.updateValueAndValidity();
  }

  onReportCollegeSelect(selected: string[]): void {
    if (this.UserCollege) {
      selected = selected.filter(college => college === this.UserCollege);
    }

    this.selectedReportColleges = selected.filter(v => v !== 'selectAll');
    this.commaSeparatedReportColleges = this.selectedReportColleges.join(',');
  }

  selectAllReportColleges(): void {
    if (this.isAllReportSelected()) {
      this.selectedReportColleges = [];
    } else {
      if (this.UserCollege) {
        this.selectedReportColleges = this.reportCollegeList
          .filter(c => c.CgCode === this.UserCollege)
          .map(c => c.CgCode);
      } else {
        this.selectedReportColleges = this.reportCollegeList.map(c => c.CgCode);
      }
    }
    this.commaSeparatedReportColleges = this.selectedReportColleges.join(',');
  }

  isAllReportSelected(): boolean {
    const availableColleges = this.UserCollege
      ? this.reportCollegeList.filter(c => c.CgCode === this.UserCollege)
      : this.reportCollegeList;

    return availableColleges.length > 0 &&
           this.selectedReportColleges.length === availableColleges.length;
  }

  isReportIndeterminate(): boolean {
    const availableColleges = this.UserCollege
      ? this.reportCollegeList.filter(c => c.CgCode === this.UserCollege)
      : this.reportCollegeList;

    return this.selectedReportColleges.length > 0 &&
           this.selectedReportColleges.length < availableColleges.length;
  }

  isReportDownloadReady(): boolean {
    const form = this.IAMarksForm;
    return form.get('SessionId')?.value &&
           form.get('course')?.value &&
           this.selectedReportColleges.length > 0 &&
           form.get('EmId')?.value;
  }

  downloadIAReport(): void {
    if (!this.isReportDownloadReady()) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Please select Session, Course, at least one College (from the multi-select dropdown), and Exam before downloading.',
        title: 'Validation Error',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    this.isDownloading = true;
    const formData = this.IAMarksForm.value;
    
    const strIdValue = formData.Branch || "0";
    
    const payload1 = {
      SessionID: formData.SessionId,
      CoCode: formData.course,
      CgCode: this.commaSeparatedReportColleges,
      EmId: formData.EmId,
      StrId: strIdValue,   
      Preview: 1
    };

    const jsonString = JSON.stringify(payload1);
    const filter = {
      LoginId: parseInt(sessionStorage.getItem('userId')) || 0,
      RptCode: 302,
      InstName: '',
      InstNo: this.umsService.secretdata?.['ClubPartTrans'] || 0,
      ShId: '',
      CgCode: '',
      RollNo: '',
      Cent: '',
      TnCode: '',
      EsId: 0,
      CsNo: '',
      PgBreak: '',
      StrId: strIdValue,  
      StrCode: '',
      RgNo: '',
      UC: '',
      Ledger: '',
      RegnRoll: '',
      DsCode: '',
      CoCode: '',
      SnNo: payload1.SessionID,
      Extra1: jsonString,
      Mode: true
    };

    this.umsService.setData(JSON.stringify(filter));
    this.router.navigate(['hbsreports']);

    setTimeout(() => {
      this.isDownloading = false;
    }, 1000);
  }
}